module.exports = __webpack_public_path__ + "static/img/格物智安工地安全管理平台操作说明-9.d230030.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/documentation/格物智安工地安全管理平台操作说明-9.jpg
// module id = Yil6
// module chunks = 0